module.exports = __webpack_public_path__ + "static/email-e4a9bba47fcc764a3c7b499bb0361b13.jpg";